import { createContext, useContext } from 'react';
import type { TrackingContextValue } from './tracking.types';

const defaultContext: TrackingContextValue = {
  module: 'Unknown',
  screen: 'Unknown',
};

export const TrackingContext = createContext<TrackingContextValue>(defaultContext);

export const useTrackingContext = (): TrackingContextValue => useContext(TrackingContext);
